import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { AlarisDateFormatService, DateFormatPipe, TOOLTIP_COMPONENT_DATA } from '@campaign-portal/components-library';
import { TranslateModule } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import {
	CampaignNextRunDay,
	CampaignSchedulerUtilsService,
} from '../../../../campaign-wizard/campaign-completed/campaign-scheduler/campaign-scheduler-utils.service';
import { CampaignInfo, CampaignStatus } from '@campaign-portal/namespace/entities/campaigns/specs';

interface ComponentData {
	nextRunAt: string;
	info: CampaignInfo;
}

@Component({
	selector: 'app-campaign-next-repeat',
	imports: [DateFormatPipe, TranslateModule, DatePipe],
	templateUrl: './campaign-next-repeat.component.html',
	styleUrl: './campaign-next-repeat.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CampaignNextRepeatComponent {
	constructor(
		@Inject(TOOLTIP_COMPONENT_DATA) public readonly data: ComponentData,
		public readonly dateFormat: AlarisDateFormatService,
		public readonly utils: CampaignSchedulerUtilsService
	) {}

	protected readonly CampaignNextRunDay = CampaignNextRunDay;
	protected readonly CampaignStatus = CampaignStatus;
}
